var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.closedBannerAlert && _vm.bannerAlertInfo.active)?_c('b-alert',{attrs:{"show":"","dismissible":"","variant":"warning","fade":""},on:{"dismissed":function($event){_vm.closedBannerAlert = true}}},[_c('span',[_vm._v(_vm._s(_vm.bannerAlertInfo.text))])]):_vm._e(),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }